// Required JS from local files
import {
   addInitialFunction,
   dfmAlert,
   dfmDialog,
} from './dfm5';
import { posthogPageviewEvent } from '~/utils/posthog/general';

// CSS
import './donate.css'

const MONTHLY_AMOUNTS = [5, 10, 15, 25, 50];
const ONEOFF_AMOUNTS = [5, 10, 30, 100, 500]; // [10, 25, 40, 75, 100];
var notifiedLargeDonation = false;

$(document).ready(function() {
   addInitialFunction(posthogPageviewEvent);

   // Also send a page view event if we've navigated here via the bfcache
   window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
         posthogPageviewEvent();
      }
   });

   $("#donate-form ul label").click(function() {
      $(this).closest('ul').find('label').removeClass('highlighted');
      $(this).addClass('highlighted');
   });
   $("#donate-form input:checked").click();

   $("#frequency label").click(function() {
      $("#giftamount").empty();
      var amounts = $("input[name=freq]:checked").val()=="monthly" ? MONTHLY_AMOUNTS : ONEOFF_AMOUNTS;
      $.each(amounts, function(k,v) {
         $("#giftamount").append("<li><label><input name='amount' type='radio' checked value='"+v+"'> £"+v+"</label></li>");
      });
      $("#giftamount").append("<li><label><input name='amount' type='radio' checked value='other'><span id='donate-other'>Other</span></label></li>");
      $("#giftamount label").click(function() {
         $(this).closest('ul').find('label').removeClass('highlighted');
         $(this).addClass('highlighted');
         if($(this).find('input').val()=="other") {
            $("#donate-other").html("£<input type='text' name='donate-other-amount'>");
            $("input[name=donate-other-amount]").focus();
         }
         else $("#donate-other").html("Other");

         $("input[name=donate-other-amount]").keyup(function(){
            var amount = $(this).val();
            if(amount>1000 && !notifiedLargeDonation) {
               notifiedLargeDonation = true;
               dfmAlert("For larger donations, you may want to consider donating via a direct transfer, so our charity avoids PayPal's transaction fees. Please contact <a href='mailto:support@drfrost.org'>support@drfrost.org</a> if you wish to discuss a larger donation.");
            }
         });

      });
      $("#giftamount label").eq(1).click();

   });
   $("#frequency input:checked").click();

   $("#school-search").dfmSchoolSelector({callback: function(school){
     $("input[name=nominate-sid]").val(school.id);
     $("#school-tick").show();
   }});
   $("#nominate-link").click(function(){
      if(!$("#nominate-form").is(":visible")) {
         $("#nominate-form").show();
         $("#nominate-form-container").addClass('open');
      } else {
         $("#nominate-form").hide();
         $("#nominate-form-container").removeClass('open');
         $("input[name=nominate-sid]").val(""); // remove school nomination
         $("#school-search").val("");
      }
   });

   $("#donate-form form").submit(function(){

      var amount = $("input[name=amount]:checked").val();
      if(amount.length>0 && amount[0]=="£") {
         amount = amount.substr(1);
         $("input[name=amount]:checked").val(amount);
      }
      if(!amount) {
         dfmAlert("No donation amount was specified.");
         return false;
      }
      if(amount=="other") {
         var otherAmount = $("input[name=donate-other-amount]").val();
         if(!$.isNumeric(otherAmount) || Number(otherAmount) < 0) {
            dfmAlert("The donation amount is not valid.");
            return false;
         }
         if(Number(otherAmount) < 1) {
            dfmAlert("The minimum donation amount is £1.");
            return false;
         }
      }


/*
      if(!$("#donate-form input[name=name]").val()) {
         dfmAlert("Your name is required.");
         return false;
      }
      if(!$("#donate-form input[name=email]").val()) {
         dfmAlert("Your email is required. A receipt of your donation will be sent to this email address.");
         return false;
      }
*/
      if($("input[name=amount]:checked").val()=="other" && !$("input[name=donate-other-amount]").val()) {
         dfmAlert("You chose to specify a custom donation amount. Please specify an amount.");
         return false;
      }
      if($("#school-search").val() && !$("input[name=nominate-sid]").val()) {
         dfmAlert("When you type in the name of a school into the search, you must select one of the search results so we can determine the exact match.");
         return false;
      }

      if($("input[name=giftaid-checkbox]").is(":checked")) {
         $("input[name=giftaid]").val(1);
         var giftAidTitle = $("input[name=giftaid-title]").val();
         var giftAidName = $("input[name=giftaid-name]").val();
         var giftAidHouseNumber = $("input[name=giftaid-housenumber]").val();
         var giftAidPostCode = $("input[name=giftaid-postcode]").val();
         if(!giftAidTitle || !giftAidName || !giftAidHouseNumber || !giftAidPostCode) {
            var giftAidHTML = "<div id='giftaid-form'><p>In order to claim gift aid on your donation, we require your name and address by law. <strong>This data will be used only for claims purposes and will be deleted after Gift Aid is claimed.</strong></p>";
            giftAidHTML+= "<label>Title:</label><input type='text' name='giftaidform-title' style='width:100px'><br>";
            giftAidHTML+= "<label>Full Name:</label><input type='text' name='giftaidform-name'><br>";
            giftAidHTML+= "<label>House Number/Name:</label><input type='text' name='giftaidform-housenumber'><br>";
            giftAidHTML+= "<label>Postcode:</label><input type='text' name='giftaidform-postcode'></div>";
            dfmDialog(giftAidHTML, [{label: "Submit", action: function(){
               $("input[name=giftaid-title]").val($("input[name=giftaidform-title]").val());
               $("input[name=giftaid-name]").val($("input[name=giftaidform-name]").val());
               $("input[name=giftaid-housenumber]").val($("input[name=giftaidform-housenumber]").val());
               $("input[name=giftaid-postcode]").val($("input[name=giftaidform-postcode]").val());
               $("#donate-form form").submit(); // resubmit form with completed Gift Aid info.
            }}]);
            return false;
         }
      } else {
         $("input[name=giftaid]").val(0);
      }

      return true;
   });

   $("#donate-privacy").click(function(){
      dfmAlert("<p>As per our full <a href='/privacy.php'>Privacy Policy</a>, your data is securely stored and will not be passed on to other third-parties.</p>"
         +"<p>Where name and email address are included, we may on the rare occasion communicate regarding fundraising updates. However, you will be able to unsubscribe at any time using the link in the email.</p>");
   });

});
